export default __webpack_public_path__ + "static/media/apple.711f993d.svg";